import { writable } from 'svelte/store';

export const appStatus = writable({
  primary: 'Offline-ready',
  secondary: 'Sign in to scan channels'
});

export const notifications = writable([]);

export function pushNotice(message, tone = 'info') {
  const id = crypto.randomUUID();
  notifications.update((items) => [
    { id, message, tone, createdAt: new Date().toISOString() },
    ...items
  ]);
  setTimeout(() => removeNotice(id), 4500);
}

export function removeNotice(id) {
  notifications.update((items) => items.filter((item) => item.id !== id));
}
